<template>
    <div>
        <a-spin :spinning="isLoading">
            <a-row type="flex" align="middle" justify="space-between" class="mb-1">
                <a-button @click="$router.back()" type="link">
                    Regresar
                </a-button>
                <a-button v-if="loggedUserIsAdmin">
                    <a :href="`${url}/get-file-order?id=${$route.params.id}`" target="_blank">Descargar txt</a>
                </a-button>
                <a-button @click="print">
                    {{ lang.order.print }}
                </a-button>
            </a-row>
            <a-card>
                <table id="target_to_print">
                    <thead>
                        <tr>
                            <th>{{ lang.order.id }}</th>
                            <th>{{ lang.order.code }}</th>
                            <th>{{ lang.order.by }}</th>
                            <th>{{ lang.order.requested_at }}</th>
                            <th colspan="3">{{ lang.order.status }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="order.id">
                            <td>{{ order.id }}</td>
                            <td>{{ order.user.username }}</td>
                            <td>{{ order.user.name }}</td>
                            <td>{{ new Date(order.created_at).toLocaleDateString() }}</td>
                            <td colspan="3">{{ lang.order.status_codes[order.status] }}</td>
                        </tr>
                        <tr>
                            <td :colspan="8" class="text-center center">
                                <h3 class="mb-0">{{ lang.order.items }}</h3>
                            </td>
                        </tr>
                        <tr>
                            <th>{{ lang.order.name }}</th>
                            <th>Reloj</th>
                            <!-- <th>Referencia</th> -->
                            <th>Fondo de caja</th>
                            <th>{{ lang.order.type }}</th>
                            <th>{{ lang.order.quantity }}</th>
                        </tr>
                        <tr v-for="(item, key) in parse(order.items)" :key="key">
                            <td colspan="1">{{ item.name }}</td>
                            <td>{{ item.watch || '-- SIN DATOS --' }}</td>
                            <!-- <td>{{ item.reference || '-- SIN DATOS --' }}</td> -->
                            <td>{{ item.case_f || '-- SIN DATOS --' }}</td>
                            <td>{{ lang.watch.main_table[item.field] }}</td>
                            <td style="text-align: right; padding: 0 10px">{{ item.quantity }}</td>
                        </tr>
                        <tr>
                            <td colspan="3" style="border: none;"></td>
                            <td style="border: none; text-align: right;"><strong>{{ lang.order.total }}:</strong></td>
                            <td style="text-align: right; padding: 0 10px"><strong>{{ parse(order.items || []).reduce((a,b) => a + b.quantity, 0) }}</strong></td>
                        </tr>
                    </tbody>
                </table>
            </a-card>
        </a-spin>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import {URL} from '@/constants'
export default {
    name: ``,
    props: {},
    data: () => ({
        url:URL
    }),
    computed: {
        ...mapGetters({
            lang: 'lang',
            loggedUserIsAdmin: 'session/loggedUserIsAdmin',
        }),
        ...mapState({
            order: state => state.order.order,
            isLoading: state => state.order.isLoading
        }),
    },
    methods: {
        ...mapActions({
            fetchOrder: 'order/fetchOrder'
        }),
        parse(items) {
            return typeof items === 'string' ? JSON.parse(items).orders.data : items
        },
        print() {
            print();
        }
    },
    mounted() {
        this.fetchOrder({ id: this.$route.params.id, force: true })
    }
}
</script>

<style lang="scss" scoped>
    table {
        width: 100%;

        td, th {
            padding: 8px 5px;
            border: 1px solid #ccc;
        }

        th {
            text-align: center;
        }
    }

    .borderless {
        border: none;
    }

    .spin-content {
        border: 1px solid #91d5ff;
        background-color: #e6f7ff;
        padding: 30px;
    }
</style>